import React, { useEffect, useRef } from 'react'
interface Propstype{
    keyword:string,onChangeHandler:(e: React.ChangeEvent<HTMLInputElement>)=>void, placeholder:string, id:string
}
export const FindUser = ({ keyword,onChangeHandler, placeholder, id }:Propstype) => {
    const inpRef = useRef<HTMLInputElement>(null)
    useEffect(() => {
        inpRef.current?.focus()
    }, [])
    return (
        <div>
            <input ref={inpRef} value={keyword} onChange={(e)=>onChangeHandler(e)} type="text" className="form-control" placeholder={placeholder} id={id} />
        </div>
    )
}